import { Badge, Flex, LoadingOverlay } from '@mantine/core';
import { IconBarbellFilled, IconHexagonNumber7Filled, IconSettings } from '@tabler/icons-react';
import React, { useState } from 'react';
import colors from '../utils/colors';
import { useProfile } from '../hooks/useProfile';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const Header: React.FC = () => {
  const navigate = useNavigate();
  const { data, isLoading } = useProfile();
  const { translate } = useLanguage();

  const handleSettingsClick = () => {
    navigate('/ustawienia');
  };

  return (
    <header className="fixed top-0 w-full flex justify-between items-center p-2 bg-custom36p text-white z-40">
      <Flex pos={'relative'}>
        <LoadingOverlay
          visible={isLoading}
          zIndex={2}
          overlayProps={{ radius: 'sm', blur: 2 }}
          loaderProps={{ color: colors.custom36s, type: 'bars' }}
          transitionProps={{ transition: 'fade', duration: 200 }}
          h={'100%'}
          styles={{overlay: {background: 'transparent'}}}
        />
        <Badge c={colors.white} size='md' fw={700} color={colors.custom36p}>
              {data?.studio.name}
        </Badge>
      </Flex>
      <Flex direction={'row'} gap={12}>
        <div className="text-xs font-semibold flex items-center justify-center gap-1 tracking-widest">
          {data ? translate('level', { level: data.level }) : <></>}
        </div>
        <IconSettings 
          size={20} 
          color={colors.white} 
          onClick={handleSettingsClick}
        />
      </Flex>
    </header>
  );
};

export default Header;

